import React from 'react';
import styled from "styled-components";

const WrapperStyled = styled.div`
    width: 700px;
    text-align: center;
    font-size: 24px;
`;

const EmptyList = ({children}) => {
    return (
        <WrapperStyled>
            <div>
                There is no items yet
            </div>
            <div>
                {children}
            </div>
        </WrapperStyled>
    );
};

export default EmptyList;